import type {
  pointTransactionDetailResource,
  pointTransactionResource,
} from '@porotutu/api/features/crm/point_transactions/resource'
import { exportHrefFor, unwrap } from '@porotutu/react/api'
import type { ListMeta, ListQuery } from '@porotutu/react/paging'
import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { crm } from '@/api/client'
import { POINT_TRANSACTIONS } from '@/api/keys'
import type { CrmPointTransactionSort, PointTransactionType } from '../vocabulary'

export type PointTransaction = ReturnType<typeof pointTransactionResource>

export type PointTransactionDetail = ReturnType<typeof pointTransactionDetailResource>

export type PointTransactionPage = { data: PointTransaction[]; meta: ListMeta }

export type PointTransactionListQuery = ListQuery<CrmPointTransactionSort, never> & {
  voucher_id?: string
  campaign_id?: string
  customer_id?: string
  order_id?: string
  transaction_type?: PointTransactionType
}

const routes = crm['point-transactions']

export const pointTransactionsQuery = (query: PointTransactionListQuery) =>
  queryOptions({
    queryKey: [...POINT_TRANSACTIONS, 'list', query] as const,
    queryFn: async () => unwrap(await routes.get({ query })),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  })

export const pointTransactionQuery = (id: string) =>
  queryOptions({
    queryKey: [...POINT_TRANSACTIONS, 'record', id] as const,
    queryFn: async () => unwrap(await routes({ id }).get()),
    staleTime: 30_000,
  })

export const exportHref = exportHrefFor<PointTransactionListQuery>(
  '/api/v1/crm/point-transactions/export',
  {
    always: ['voucher_id', 'campaign_id', 'customer_id', 'order_id'],
    viewed: ['transaction_type', 'search'],
  },
)
